import { createHeadlessEditor } from "@lexical/headless";
import { $convertFromMarkdownString } from "@lexical/markdown";
import { MERGE_TAG, TRANSFORMERS } from "../../../discover/transformers";
import { makeEmptySerializedState } from "../../../email-design/util";
import { DefaultProportionOfMaxWidth } from "../nodes/design-huddle-node";
import { EDITOR_NODES_HEADLESS } from "./nodes-headless";

import type { Json } from "../../../../__definitions__/database-definitions";
import type { BrandKitImageType } from "../../../brand-kit/server/brand-kit-service";
import type { SerializedEditorState } from "lexical";

interface DesignHuddleInfo {
  project_id: string;
  account_id: string;
  page_number: number;
  image_type?: BrandKitImageType;
}

export function markdownToCommunicationDesign(
  content: string,
  format: "email" | "chat" | "sms",
  designHuddleInfo?: DesignHuddleInfo,
): Json & SerializedEditorState {
  const editor = createHeadlessEditor({
    nodes: EDITOR_NODES_HEADLESS[format],
  });

  editor.update(
    () =>
      // replace all nbsp with space to avoid markdown parser issues
      // Replace all "\\-" with "-" to avoid markdown parser issues
      $convertFromMarkdownString(content.replaceAll(/^\u00A0+/gm, " ").replaceAll(/\\-/g, "-"), [
        ...TRANSFORMERS(format),
        MERGE_TAG,
      ]),
    {
      discrete: true,
    },
  );

  const children = [
    ...(designHuddleInfo
      ? [
          {
            type: "design-huddle",
            id: designHuddleInfo.project_id,
            account_id: designHuddleInfo.account_id,
            version: 2,
            page_number: designHuddleInfo.page_number,
            format: "",
            aspect: designHuddleInfo.image_type === "banner" ? 3 : 1,
            proportionOfMaxWidth: DefaultProportionOfMaxWidth,
            cacheBustNumber: 1,
            mustBeCloned: null,
            customisations: null,
            href: null,
          },
        ]
      : []),
    ...editor.getEditorState().toJSON().root.children,
  ];

  const data = makeEmptySerializedState(children);

  // HACK: At the moment lexical dose not implement markdown escapes; do the only one we use.
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  const escapedData = JSON.parse(JSON.stringify(data).replaceAll(String.raw`\\.`, ".")) as Json &
    SerializedEditorState;
  return escapedData;
}
